import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Search, Filter, X } from 'lucide-react';
import axios from "axios";
import { product_uri, products_uri } from '../../../uri';
import { baseUrlLink, PROD_TYPES, PRODUCT_TYPES } from '../../../utils/type';
import moment from "moment";

const Products = () => {
  const [activeFilter, setActiveFilter] = useState(PRODUCT_TYPES.ZAHIALGA);
  const [searchQuery, setSearchQuery] = useState('');
  const [load, setLoad] = useState(false);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);


  useEffect(() => {
    Get();
  }, [activeFilter]);

  const Get = async (newPage = 1) => {
    setLoad(true);
    try {
      const res = await axios.get(product_uri + `?page=${newPage}&product_type=${activeFilter}&limit=20&name=${searchQuery}`);
      if (newPage === 1) {
        setProducts(res.data.data); // эхний хуудсанд products шинэчилнэ
      } else {
        setProducts((prev) => [...prev, ...res.data.data]); // дараагийн хуудсанд products нэмнэ
      }
      setLoad(false);
    } catch (err) {
      setLoad(false);
      console.log(err);
    }
  };
  
  

  const getProductUrl = (product) => {
    return product.product_type === PRODUCT_TYPES.BELEN ? `/belen/${product.id}` : `/zahialga/${product.id}`;
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      Get();
      setPage(1);
    }
  };

  return (
    <div className="text-black mt-8 px-4 xs:max-w-xl md:max-w-4xl mx-auto">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-bold text-xl uppercase">Бараанууд</h1>
          <p className="text-gray-600">Бэлэн болон захиалгын бараа</p>
        </div>
      </div>
      <div className='flex mt-2'>
        <div className='flex p-1 items-center gap-2 bg-white rounded-md'>
          <h1 className={activeFilter === PRODUCT_TYPES.ZAHIALGA ? 'bg-red-600 text-white rounded-md p-1 cursor-pointer text-sm' : 'rounded-md p-1 cursor-pointer text-sm'} onClick={(e)=> setActiveFilter(PRODUCT_TYPES.ZAHIALGA)}>Захиалгын бараа</h1>
          <h1 className={activeFilter === PRODUCT_TYPES.BELEN ? 'bg-red-600 text-white rounded-md p-1 cursor-pointer text-sm' : 'rounded-md p-1 cursor-pointer text-sm'}  onClick={(e)=> setActiveFilter(PRODUCT_TYPES.BELEN)}>Бэлэн бараа</h1>
        </div>
      </div>

      {/* Search and Filter */}
      <div className="mt-4 flex gap-2">
        <div className="relative flex-grow">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            <Search size={18} className="text-gray-500" />
          </div>
          <input
            type="text"
            onKeyDown={handleKeyDown}
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full pl-10 p-2.5"
            placeholder="Хайх..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button 
              className="absolute inset-y-0 right-0 flex items-center pr-3"
              onClick={() => setSearchQuery('')}
            >
              <X size={18} className="text-gray-500" />
            </button>
          )}
        </div>
      </div>

      {/* Products Grid */}
      <div className="mt-4">
        {
        load ? (
          <div className="text-center py-8">
            <p className="text-gray-500">Уншиж байна ...</p>
          </div>
        ) :
        products.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-500">Бараа олдсонгүй</p>
          </div>
        ) : (
          <div>
            <div className="grid grid-cols-2 gap-4">
              {products.map((product) => (
                <Link 
                  key={product.id} 
                  to={getProductUrl(product)} 
                  className="bg-white p-3 rounded-xl relative hover:shadow-md transition-shadow"
                >
                  <img
                    className="rounded-xl w-full h-40 object-cover"
                    src={baseUrlLink+product.images[0]?.url}
                  />
                  <div className="flex mt-3 items-center justify-between">
                    <h1 className="text-lg">{product.name}</h1>
                    <h1 className="font-bold text-lg">{product.price}₮</h1>
                  </div>
                  <h1 className="text-sm">{product.colors.length} өнгө</h1>
                  <div className='flex'>
                    <h1 className="text-sm bg-gray-100 rounded-md p-1">
                      {
                        product.type == PROD_TYPES.AYLAL &&
                        "Аялалын хэрэгсэл"
                      }
                      {
                        product.type == PROD_TYPES.BELEN_CLOTHS &&
                        "Бэлэн хувцас"
                      }
                      {
                        product.type == PROD_TYPES.GER &&
                        "Гэр ахуй"
                      }
                      {
                        product.type == PROD_TYPES.GOYL &&
                        "Гоёл  чимэглэл"
                      }
                      {
                        product.type == PROD_TYPES.HUUHED_HUVTSAS &&
                        "Хүүхдийн хувцас"
                      }
                      {
                        product.type == PROD_TYPES.HUUHED_HEREGSEL &&
                        "Хүүхдийн хэрэгсэл"
                      }
                      {
                        product.type == PROD_TYPES.TSAHILGAAN &&
                        "Цахилгаан хэрэгсэл"
                      }
                    </h1>
                  </div>
                  {
                    product.product_type == PRODUCT_TYPES.ZAHIALGA &&
                    <div className='mt-1'>
                      <h1 className='text-sm'>Захиалга хаах хугацаа</h1>
                      <p className='text-xs'>{moment(product.end_date).format('YYYY-MM-DD HH:MM')}</p>
                    </div>
                  }
                </Link>
              ))}
            </div>
            {products.length > 19 && (
              <div className="text-center mt-6">
                <button
                  onClick={() => {
                    const nextPage = page + 1;
                    setPage(nextPage);
                    Get(nextPage);
                  }}
                  className="px-3 py-1 transition bg-gray-100 rounded-xl"
                >
                  See more
                </button>
              </div>
            )}
          </div>
          
        )}
      </div>
    </div>
  );
};

export default Products;